export enum DecisionModelProcessType {
  UNKNOWN = 'UNKNOWN',
  DECISION_MODEL_WORKFLOW = 'DECISION_MODEL_WORKFLOW',
  DOCUMENT_ISSUE = 'DOCUMENT_ISSUE',
  ACCOUNT_DISPERSION = 'ACCOUNT_DISPERSION',
  FINAL_DECISION = 'FINAL_DECISION',
}
